import React from 'react'

interface SwiperControlsProps {
    uniqueId: string
    className?: string
    showNavigation?: boolean
    showPagination?: boolean
}

interface SwiperNavigationProps {
    uniqueId: string
    className?: string
    headingId?: string
}
interface SwiperPaginationProps {
    uniqueId: string
    className?: string
}

// export const swiperNavigationOptions = {
//     lockClass: 'swiper-navigation__button--lock',
// }

export const swiperPaginationOptions = {
    clickable: true,
    bulletElement: 'button',
    dynamicBullets: true,
    dynamicMainBullets: 3,
}

export const SwiperNavigation = ({ uniqueId, className, headingId = '' }: SwiperNavigationProps) => {
    const prevButtonClass = `button-swiper-navigation swiper-navigation__button swiper-navigation__button-prev swiper-navigation__button-prev-${uniqueId}`
    const nextButtonClass = `button-swiper-navigation swiper-navigation__button swiper-navigation__button-next swiper-navigation__button-next-${uniqueId}`

    return (
        <div className={`swiper-navigation ${className}`}>
            <button className={prevButtonClass} aria-describedby={headingId} aria-label={`{{js.swiper.carousel.navigation.button.previous.aria-label}}`}>
                <span className="sr-only">{`{{js.swiper.carousel.navigation.button.previous.aria-label}}`}</span>
            </button>
            <button className={nextButtonClass} aria-describedby={headingId} aria-label={`{{js.swiper.carousel.navigation.button.next.aria-label}}`}>
                <span className="sr-only">{`{{js.swiper.carousel.navigation.button.next.aria-label}}`}</span>
            </button>
        </div>
    )
}

export const SwiperPagination = ({ uniqueId, className = '' }: SwiperPaginationProps) => {
    const paginationClass = `swiper-pagination swiper-pagination-${uniqueId}`

    return (
        <nav className={`${paginationClass} ${className}`}></nav>
    )
}

const SwiperControls = ({
    uniqueId,
    className = '',
    showNavigation = true,
    showPagination = true,
}: SwiperControlsProps) => {
    const prevButtonClass = `swiper-navigation__button swiper-navigation__button-prev swiper-navigation__button-prev-${uniqueId}`
    const nextButtonClass = `swiper-navigation__button swiper-navigation__button-next swiper-navigation__button-next-${uniqueId}`
    const paginationClass = `swiper-pagination swiper-pagination-${uniqueId}`

    return (
        <div className={`swiper-controls ${className}`}>
            {showNavigation && (
                <div className="swiper-navigation">
                    <button className={prevButtonClass} aria-label={`{{js.swiper.carousel.navigation.button.previous.aria-label}}`}></button>
                    <button className={nextButtonClass} aria-label={`{{js.swiper.carousel.navigation.button.next.aria-label}}`}></button>
                </div>
            )}
            {showPagination && <nav className={paginationClass}></nav>}
        </div>
    )
}

export default SwiperControls
